export const IfTrue = ({ value, children }) => {
  return value ? children : null;
};
